import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {checkIsHubspotConnected} from '../../../../helpers/integrationHelpers';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {CrmSyncSourcesEnum} from '../../../../models/api/crmSyncModel';
import {getCompanyHasCrmSyncFeature} from '../../../../store/data/company/companySelectors';
import {
  disableCrmSyncAsyncAction,
  fetchOrCreateCrmSyncResourceAsyncAction,
} from '../../../../store/data/crmSync/crmSyncActions';
import {
  makeGetActiveSyncJob,
  makeGetCrmAccountSyncViaSource,
} from '../../../../store/data/crmSync/crmSyncSelectors';
import {getCustomFieldsForAccountsFlat} from '../../../../store/data/customFields/customFieldsSelectors';
import {getHubspotIntegration} from '../../../../store/data/integrations/integrationSelectors';
import {getIsUserGlobalAdmin} from '../../../../store/data/teammates/teammatesSelectors';
import {HubspotCrmSyncDialogWrapper} from './hubspotCrmSyncDialogWrapper';

/*
 * Selectors.
 */

export function makeGetIsConnected() {
  return createSelector([getHubspotIntegration], checkIsHubspotConnected);
}

export function makeGetHubspotUsername() {
  return createSelector([getHubspotIntegration], (hubspotIntegration) => {
    if (!hubspotIntegration) {
      return undefined;
    }
    return hubspotIntegration.settings.readonly?.username;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => {
  const getCrmSync = makeGetCrmAccountSyncViaSource(CrmSyncSourcesEnum.HUBSPOT);
  const getActiveSyncJob = makeGetActiveSyncJob(getCrmSync);
  const getHubspotUsername = makeGetHubspotUsername();
  const getIsConnected = makeGetIsConnected();
  return {
    crmSync: getCrmSync,
    activeSyncJob: getActiveSyncJob,
    username: getHubspotUsername,
    isConnected: getIsConnected,
    hasCrmSyncFeature: getCompanyHasCrmSyncFeature,
    customFields: getCustomFieldsForAccountsFlat,
    isAdmin: getIsUserGlobalAdmin,
  };
});

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  fetchOrCreateCrmSyncResourceAsync: fetchOrCreateCrmSyncResourceAsyncAction,
  disableCrmSyncAsync: disableCrmSyncAsyncAction,
}));

export const HubspotCrmSyncDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HubspotCrmSyncDialogWrapper);
